var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPostGifts)?_c('div',[_c('gift-multiple',{attrs:{"type":"creatorPost","id":_vm.creatorPost.id,"sentGiftIds":_vm.creatorPost.sentGiftIds}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }